import { render, staticRenderFns } from "./SavingSpinner.vue?vue&type=template&id=600fa818"
import script from "./SavingSpinner.vue?vue&type=script&lang=js"
export * from "./SavingSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports